<script>
import axios from 'axios'
import vSelect from 'vue-select'
import { eventBus } from '@/vcs/_shared/eventBus'
import TransformOptions from '@/mixins/TransformOptions.js'

export default {
  components: { vSelect },
  mixins: [TransformOptions],
  props: {
    user: Object
  },
  data: function () {
    return {
      localUser: null,
      users: []
    }
  },
  watch: {
    user: function (newVal) {
      if (newVal == null) {
        this.localUser = null
      }
    },
    localUser: function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        this.$emit('option:selected', this.localUser)
      }
    }
  },
  methods: {
    fetchUsers(search, loading) {
      eventBus.$emit('refresh-token-via-websockets')
      if (search.length >= 3) {
        loading(true)
        axios({
          method: 'get',
          url: `collection_points/${this.$deviceId()}/users`,
          params: {
            'q[query]': search
          }
        })
          .then((response) => {
            let threeFirstUsers = response.data.slice(0, 3)
            this.users = this.transformOptions(threeFirstUsers)
          })
          .catch((error) => {
            this.$errorHumanized(error)
          })
          .finally(() => {
            loading(false)
          })
      } else if (search.length == 0) {
        this.users = []
      }
    }
  }
}
</script>

<template lang="pug">
v-select(
  label="itemData"
  v-model="localUser"
  :options="users"
  :placeholder="$t('d.start.userSearchInput.placeholder')"
  @search="fetchUsers"
  @search:blur="$slideDown()"
  @search:focus="$emit('search:focus')"
)
  span(slot="no-options") {{ $t('noSearchResults') }}
  template(#selected-option="{ name, email, phone, phonePrefix }")
    span(v-if="name && phone && email") {{ name }} (+{{ phonePrefix || '48' }} {{ phone }} | {{ email }})
    span(v-else-if="phone && email") +{{ phonePrefix || '48' }} {{ phone }} | {{ email }}
    span(v-else-if="name && email") {{ name }} ({{ email }})
    span(v-else-if="email") {{ email }}
    span(v-else) {{ name }} (+{{ phonePrefix || '48' }} {{ phone }} | {{ email }})

  template(#option="{ name, email, phone, phonePrefix }")
    h4.m-0
      span(v-if="name && email") {{ name }}, {{ email }}
      span(v-else-if="name") {{ name }}
      span(v-else-if="email") {{ email }}
    .text-muted.fs-1-6rem(v-if="phone") +{{ phonePrefix || '48' }} {{ phone }}
</template>
